"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const consts_1 = require("../consts");
function isModuleCorrect(moduleStat) {
    return moduleStat.score === consts_1.CORRECT_SCORE;
}
exports.default = isModuleCorrect;
